import { hasPermission } from '@/hooks/usePermission'
import { getPermissions } from '@/stores/session'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

// The parent layout has loaded the grants by now. UX only: the roster API
// answers 403 on its own (`SUP-41`).
export const Route = createFileRoute('/_contractor/team')({
  beforeLoad: () => {
    if (!hasPermission(getPermissions(), 'own_company_roster', 'read')) {
      throw redirect({ to: '/quotes' })
    }
  },
  component: Outlet,
})
